export default __webpack_public_path__ + "static/media/email_icon.73d8d97e.svg";